import { z } from 'zod';

export const newWorkspaceSchema = z.object({
  name: z.string().min(2, 'Name is required'),
});
